/**
 * Module dependencies.
 */

import { useEffect } from 'react';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import { zIndex } from 'src/styles/z-index';

/**
 * `Props` type.
 */

type Props = {
  off: boolean;
};

/**
 * `useBodyScroll` hook.
 */

function useBodyScroll({ off }: Props) {
  const locomotiveScroll = useLocomotiveScroll();

  useEffect(() => {
    const main = document.querySelector('main');
    const scrollbar = document.querySelector(
      '.c-scrollbar_thumb'
    ) as HTMLElement;

    const navbarUnderlay = document.querySelector('nav > div') as HTMLElement;

    if (!off) {
      return;
    }

    locomotiveScroll.scroll.stop();
    navbarUnderlay.style.backgroundColor = 'transparent';
    main.style.position = 'fixed';
    main.style.zIndex = zIndex.filters.toString();

    if (scrollbar) {
      scrollbar.hidden = true;
    }

    return () => {
      locomotiveScroll.scroll.start();
      navbarUnderlay.style.backgroundColor = '#fff';
      main.style.position = 'unset';
      main.style.zIndex = 'unset';

      if (scrollbar) {
        scrollbar.hidden = false;
      }
    };
  }, [locomotiveScroll.scroll, off]);
}

/**
 * Export `useBodyScroll` hook.
 */

export default useBodyScroll;
